(function() {
    'use strict';

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    function init() {
        initProductTabs();
        initQuantityControls();
        initThumbnailGallery();
        initProductReviews();
        initAddToCart();
        console.log('Blue Love Product Page Loaded ✨');
    }

    // ================================
    // PRODUCT TABS
    // ================================
    function initProductTabs() {
        const tabButtons = document.querySelectorAll('.tab-button');
        const tabPanels = document.querySelectorAll('.tab-panel');

        if (tabButtons.length === 0) return;

        tabButtons.forEach(function(button) {
            button.addEventListener('click', function() {
                const tabId = this.getAttribute('data-tab');

                // Remove active class from all
                tabButtons.forEach(function(btn) {
                    btn.classList.remove('active');
                });
                tabPanels.forEach(function(panel) {
                    panel.classList.remove('active');
                });

                // Add active to clicked
                this.classList.add('active');
                const targetPanel = document.getElementById(tabId);
                if (targetPanel) {
                    targetPanel.classList.add('active');
                }

                // Smooth scroll to tabs
                const tabsSection = document.querySelector('.product-tabs');
                if (tabsSection) {
                    tabsSection.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            });
        });
    }

    // ================================
    // QUANTITY CONTROLS
    // ================================
    function initQuantityControls() {
        const qtyInput = document.querySelector('.qty-input') || 
                        document.querySelector('input[name="quantity"]');
        const minusBtn = document.querySelector('.qty-btn.minus');
        const plusBtn = document.querySelector('.qty-btn.plus');

        if (!qtyInput) return;

        // Minus button
        if (minusBtn) {
            minusBtn.addEventListener('click', function() {
                let currentValue = parseInt(qtyInput.value) || 1;
                if (currentValue > 1) {
                    qtyInput.value = currentValue - 1;
                    triggerQuantityChange(qtyInput);
                }
            });
        }

        // Plus button
        if (plusBtn) {
            plusBtn.addEventListener('click', function() {
                let currentValue = parseInt(qtyInput.value) || 1;
                if (currentValue < 99) {
                    qtyInput.value = currentValue + 1;
                    triggerQuantityChange(qtyInput);
                }
            });
        }

        // Input change validation
        qtyInput.addEventListener('change', function() {
            let value = parseInt(this.value);
            if (isNaN(value) || value < 1) {
                this.value = 1;
            } else if (value > 99) {
                this.value = 99;
            }
            triggerQuantityChange(this);
        });
    }

    function triggerQuantityChange(input) {
        // Trigger Shopify's quantity change event
        const event = new Event('change', { bubbles: true });
        input.dispatchEvent(event);
    }

    // ================================
    // THUMBNAIL GALLERY
    // ================================
    function initThumbnailGallery() {
        const thumbnails = document.querySelectorAll('.thumbnail');
        const mainImage = document.querySelector('.main-image img') || 
                         document.querySelector('.product-single__photo');

        if (thumbnails.length === 0) return;

        thumbnails.forEach(function(thumb, index) {
            thumb.addEventListener('click', function() {
                // Remove active from all
                thumbnails.forEach(function(t) {
                    t.classList.remove('active');
                });

                // Add active to clicked
                this.classList.add('active');

                // Update main image if it exists
                if (mainImage) {
                    const thumbImg = this.querySelector('img');
                    if (thumbImg) {
                        mainImage.style.opacity = '0';
                        setTimeout(function() {
                            mainImage.src = thumbImg.src.replace('_small', '_large');
                            mainImage.style.opacity = '1';
                        }, 200);
                    }
                }
            });
        });
    }

    // ================================
    // ADD TO CART ENHANCEMENT
    // ================================
    function initAddToCart() {
        const addToCartBtn = document.querySelector('button[name="add"]') || 
                            document.querySelector('.product-form__submit') ||
                            document.querySelector('.add-to-cart-large');

        if (!addToCartBtn) return;

        // Listen for form submission
        const productForm = document.querySelector('form[action*="/cart/add"]');
        
        if (productForm) {
            productForm.addEventListener('submit', function(e) {
                // Let Shopify handle the actual submission
                // Just show visual feedback
                setTimeout(function() {
                    showAddToCartNotification();
                }, 500);
            });
        }
    }

    function showAddToCartNotification() {
        // Create notification
        const notification = document.createElement('div');
        notification.className = 'cart-notification-custom';
        notification.innerHTML = `
            <div class="notification-content">
                <div class="notification-icon">✓</div>
                <div class="notification-text">
                    <strong>Added to Cart!</strong>
                    <span>Product successfully added</span>
                </div>
            </div>
        `;

        // Style it
        notification.style.cssText = `
            position: fixed;
            top: 100px;
            right: 20px;
            background: white;
            padding: 1.5rem;
            border-radius: 15px;
            box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
            z-index: 10000;
            min-width: 300px;
            animation: slideInRight 0.3s ease-out;
        `;

        document.body.appendChild(notification);

        // Add animation styles if not already present
        if (!document.getElementById('cart-notification-styles')) {
            const style = document.createElement('style');
            style.id = 'cart-notification-styles';
            style.textContent = `
                @keyframes slideInRight {
                    from { transform: translateX(400px); opacity: 0; }
                    to { transform: translateX(0); opacity: 1; }
                }
                @keyframes slideOutRight {
                    from { transform: translateX(0); opacity: 1; }
                    to { transform: translateX(400px); opacity: 0; }
                }
                .cart-notification-custom .notification-content {
                    display: flex;
                    align-items: center;
                    gap: 1rem;
                }
                .cart-notification-custom .notification-icon {
                    width: 40px;
                    height: 40px;
                    background: linear-gradient(135deg, #10b981, #059669);
                    color: white;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.5rem;
                    flex-shrink: 0;
                }
                .cart-notification-custom .notification-text {
                    display: flex;
                    flex-direction: column;
                }
                .cart-notification-custom .notification-text strong {
                    color: #001a4d;
                    margin-bottom: 0.25rem;
                }
                .cart-notification-custom .notification-text span {
                    color: #6c757d;
                    font-size: 0.9rem;
                }
            `;
            document.head.appendChild(style);
        }

        // Remove after 4 seconds
        setTimeout(function() {
            notification.style.animation = 'slideOutRight 0.3s ease-out';
            setTimeout(function() {
                notification.remove();
            }, 300);
        }, 4000);
    }

    // ================================
    // PRODUCT REVIEWS
    // ================================
    function initProductReviews() {
        // Helpful button functionality
        const helpfulBtns = document.querySelectorAll('.helpful-btn');
        
        helpfulBtns.forEach(function(btn) {
            btn.addEventListener('click', function() {
                if (this.disabled) return;
                
                const currentCount = parseInt(this.textContent.match(/\d+/)[0]);
                this.textContent = 'Helpful (' + (currentCount + 1) + ')';
                this.style.borderColor = '#0066ff';
                this.style.color = '#0066ff';
                this.disabled = true;
            });
        });

        // Review count click - scroll to reviews
        const reviewCount = document.querySelector('.review-count');
        if (reviewCount) {
            reviewCount.addEventListener('click', function() {
                const reviewsTab = document.querySelector('[data-tab="reviews"]');
                if (reviewsTab) {
                    reviewsTab.click();
                }
            });
        }

        // Load more reviews button
        const loadMoreBtn = document.querySelector('.load-more-reviews');
        if (loadMoreBtn) {
            loadMoreBtn.addEventListener('click', function() {
                // Create mock review
                const reviewsList = document.querySelector('.reviews-list');
                if (!reviewsList) return;

                const newReview = document.createElement('div');
                newReview.className = 'review-item';
                newReview.innerHTML = `
                    <div class="review-header">
                        <div class="reviewer-info">
                            <strong>Happy Customer</strong>
                            <span class="verified">✓ Verified Purchase</span>
                        </div>
                        <div class="review-stars">★★★★★</div>
                    </div>
                    <h4 class="review-title">Great product!</h4>
                    <p class="review-text">Very pleased with this purchase. Quality is excellent and shipping was fast.</p>
                    <div class="review-footer">
                        <span class="review-date">Just now</span>
                        <button class="helpful-btn">Helpful (0)</button>
                    </div>
                `;

                reviewsList.appendChild(newReview);

                // Animate in
                newReview.style.opacity = '0';
                newReview.style.transform = 'translateY(20px)';
                setTimeout(function() {
                    newReview.style.transition = '0.5s ease-out';
                    newReview.style.opacity = '1';
                    newReview.style.transform = 'translateY(0)';
                }, 100);

                // Reinitialize helpful buttons
                initProductReviews();
            });
        }
    }

    // ================================
    // PRODUCT PAGE SCROLL EFFECTS
    // ================================
    window.addEventListener('scroll', function() {
        const productImages = document.querySelector('.product-images');

        if (productImages && window.innerWidth > 1024) {
            const scrolled = window.pageYOffset;
            const imageOffset = productImages.offsetTop;

            if (scrolled > imageOffset - 100) {
                const translateY = (scrolled - imageOffset) * 0.1;
                productImages.style.transform = 'translateY(' + translateY + 'px)';
            }
        }
    });

    // ================================
    // SHOPIFY CART INTEGRATION
    // ================================
    
    // Listen for Shopify cart updates
    document.addEventListener('cart:updated', function() {
        updateCartCount();
    });

    function updateCartCount() {
        fetch('/cart.js')
            .then(function(response) {
                return response.json();
            })
            .then(function(cart) {
                const cartLink = document.querySelector('.cart-link');
                if (cartLink) {
                    cartLink.textContent = 'Cart (' + cart.item_count + ')';
                }
            })
            .catch(function(error) {
                console.error('Cart update error:', error);
            });
    }

    // Update on page load
    updateCartCount();

})();